import React, { useState } from 'react';
import { Breadcrumb, Typography, Space, Grid } from 'antd';
import { HomeOutlined, UserOutlined } from '@ant-design/icons';
import CustomerList from '../components/Customers/CustomerList';

const { Title } = Typography;

const CustomersPage = () => {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    return (
        <div style={{ padding: isMobile ? '0px' : 'inherit' }}>
            <Breadcrumb
                style={{ marginBottom: isMobile ? '8px' : '16px' }}
                items={[
                    {
                        href: '/',
                        title: <HomeOutlined />,
                    },
                    {
                        title: (
                            <Space>
                                <UserOutlined />
                                <span>Customers</span>
                            </Space>
                        ),
                    },
                ]}
            />

            <div style={{ marginBottom: isMobile ? '12px' : '24px' }}>
                <Title level={isMobile ? 3 : 2} style={{ margin: 0 }}>Customers</Title>
            </div>

            <CustomerList />
        </div>
    );
};

export default CustomersPage;
